<template>
  <b-row>
    <b-col lg="12">
      <b-card header="Borradores - pendientes de envío">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <th>BL/Booking</th>
            <th>Referencia (facturación)</th>
            <th>Tipo Servicio</th>
            <th>Línea naviera</th>
            <th>Fecha (cita)</th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="(service, k) in paginated('filteredServices')"
            :key="k"
            @contextmenu.prevent="selectService(service)"
          >
            <td>{{service.doc_number}}</td>
            <td>{{service.reference}}</td>
            <td>{{service.service_type.name}}</td>
            <td>{{service.shipping_line? service.shipping_line.name : ''}}</td>
            <td>{{service.requeriments[0].date | formatDateTime}}</td>
          </tr>
          </tbody>
        </table>
        <paginate name="filteredServices" :list="filteredServices" class="paginate-list" :per="10"></paginate>
        <paginate-links
          for="filteredServices"
          :limit="5"
          :show-step-links="true"
          :step-links="{next: '>>',prev: '<<'}"
          :classes="{'ul': 'pagination','li': 'page-item','a': 'page-link'}"
        ></paginate-links>
        <context-menu id="context-menu" ref="ctxMenu">
          <li @click="editService()" class="ctx-item">Editar</li>
        </context-menu>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
  import api from "@/helpers/api";
  import constants from "@/constants";
  import {mapGetters} from "vuex";

  export default {
    data() {
      return {
        services: [],
        paginate: ["filteredServices"],
        search: "",
        constants: {}
      };
    },
    mounted() {
      let data = {
        status_code: [constants.DRAFT]
      };
      api.post(`/company_services`, data).then(response => {
        this.services = response.services;
      });
    },
    methods: {
      selectService(service) {
        this.service = service;
        this.$refs.ctxMenu.open();
      },
      editService() {
        this.$router.push(`/service/edit/${this.service.id}`);
      }
    },
    computed: {
      ...mapGetters({
        user: "user/user"
      }),
      filteredServices() {
        return this.services.filter(service => {
          return this.search
            ? service.id.toString().includes(this.search.toLowerCase())
            : true;
        });
      }
    }
  };
</script>
